export function OutlineLikeIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00232 10.998V20.9991H4.99636C3.8926 20.9991 3 20.106 3 19.0017V12.9954C3 11.8911 3.8926 10.998 4.99636 10.998H7.00232Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0022 10.9989V20.9999H17.5839C18.5869 20.9999 19.4411 20.2941 19.6042 19.3291L20.9719 11.3206C21.1783 10.1011 20.2185 8.99677 18.9516 8.99677H13.0057V6.00079C13.0057 4.34435 11.7867 3 10.0831 3L7.007 10.9989H7.0022Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
